import React from "react";
import { Avatar } from "primereact/avatar";

const AvtarComponent = ({ username }) => {
  
  // Function to get the first two initials from the username
  const getUserInitial = () => {
    if (!username) return '';
    
    const nameParts = username.split(' ');
    if (nameParts.length === 1) {
      return nameParts[0].substring(0, 2).toUpperCase(); // If only one part, return first two chars
    } else {
      return (nameParts[0][0] + nameParts[1][0]).toUpperCase(); // First letter of first and last name
    }
  };

  return (
    <Avatar
        label={getUserInitial()}
        shape="circle"
        className="message-avatar"
    />
  );
};

export default AvtarComponent;
